import { useMediaQuery, useSafeLayoutEffect } from '@hover/blueprint/chakra';
import { useState } from 'react';

import { isServer } from 'src/shared/utils/environment';

const useIsLandscape = () => {
  const [isLandscape, setIsLandscape] = useState(false);
  const [largeViewport] = useMediaQuery('(orientation: landscape)');

  useSafeLayoutEffect(() => {
    if (!isServer()) {
      setIsLandscape(largeViewport);
    }
  }, [largeViewport]);

  return [isLandscape];
};

export { useIsLandscape };
